<template>
  <v-container id="containerClientSignup" fluid>
    <!-- The layout for the whole screen. -->
    <v-layout id="containerSignupCard" justify-center align-center fill-height>
      <!-- The card that contains the signup form -->
      <v-flex class="signup-card" xs12 sm8 md6 lg4>
        <!-- Back button -->
        <v-icon
          v-if="step > 0"
          id="buttonBack"
          @click="step = --step < 0 ? 0 : step"
        >
          chevron_left
        </v-icon>
        <div class="flex-item signup-card__title">
          <div class="signup-card__title-page-name">
            {{ stepTitles[step] }}
          </div>
        </div>
        <div class="flex-item signup-card__body">
          <!-- <basic-info-page
            v-if="step === 0"
            ref="basicInfo"
            :user-info="clientData"
            @submit="submitBasicInfo"
          /> -->
          <!-- <legalities-page
            v-if="step === 0"
            ref="legalities"
            @submit="submitLegalities"
          /> -->
          <home-needs-page
            v-if="step === 0"
            ref="needs"
            :chosen="form.needs"
            :suggestions="preferenceSuggestions"
            @changed="changedWantsNeeds"
            @submit="submitNeeds"
          />
          <home-wants-page
            v-if="step === 1"
            ref="wants"
            :chosen="form.wants"
            :suggestions="preferenceSuggestions"
            @changed="changedWantsNeeds"
            @submit="submitWants"
          />
          <!-- <approval-letter-page
            v-if="step === 2"
            ref="approvalLetter"
            @submit="submitApprovalLetter"
          /> -->
          <purchase-details-page
            v-if="step === 2"
            ref="purchaseDetails"
            @submit="submitPurchaseDetails"
          />
          <span v-if="showWantsNeedsError" class="wants-needs-error">
            Select at least one Need and one Want
          </span>
        </div>
        <!-- Continue button -->
        <div class="signup-card__footer">
          <button
            v-if="step < maxStep"
            v-ripple="{ class: 'grey--text', center: true }"
            class="buttonContinue"
            @click="nextScreenBtnClick"
          >
            Next
          </button>
          <button
            v-if="step === maxStep"
            v-ripple="{ class: 'grey--text', center: true }"
            class="buttonContinue"
            @click="submitData"
          >
            Confirm
          </button>
          <div
            v-if="maxStep === 2 && step > minStep && step <= maxStep"
            class="signup_card_skip"
            @click="submitData(false)"
          >
            Skip this step
          </div>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import * as _ from 'lodash'
import { mapState } from 'vuex'
import { updateMyProfile } from '../../services/profile'

// import BasicInfoPage from '../../components/client/signup/BasicInfoPage.vue'
// import LegalitiesPage from '../../components/client/signup/LegalitiesPage.vue'
import HomeNeedsPage from '../../components/client/signup/HomeNeedsPage.vue'
import HomeWantsPage from '../../components/client/signup/HomeWantsPage.vue'
// import ApprovalLetterPage from '../../components/client/signup/ApprovalLetterPage.vue'
import PurchaseDetailsPage from '../../components/client/signup/PurchaseDetailsPage.vue'
import refreshClientData from '../../components/mixins/refreshClientData'
import { isEmpty } from '../../utils/generalUtils'

export default {
  components: {
    // BasicInfoPage,
    // LegalitiesPage,
    HomeNeedsPage,
    HomeWantsPage,
    // ApprovalLetterPage,
    PurchaseDetailsPage
  },
  mixins: [refreshClientData],
  data() {
    return {
      stepTitles: [
        // 'Create Your Account',
        // 'Legalities',
        'Add Your Home Needs',
        'Add your Home Wants',
        // 'Documents',
        'Your Purchase Details'
      ],
      showAlert: false,
      showWantsNeedsError: false,
      currentPath: '',
      formTitle: '',
      step: 0,
      form: {
        userInfo: {},
        // legalities: false,
        needs: [],
        wants: [],
        approvalLetter: null
      }
    }
  },

  computed: {
    ...mapState('client', ['clientData', 'preferenceSuggestions']),
    ...mapState('common', ['isMobile']),

    authError() {
      return this.$store.getters.authError
    },

    minStep() {
      return this.hidePurchaseDetails ? 0 : 1
    },

    maxStep() {
      return this.hidePurchaseDetails ? 1 : 2
    },

    hidePurchaseDetails() {
      return (
        this.clientData &&
        this.clientData.hasOwnProperty('priceMin') &&
        this.clientData.priceMax &&
        this.clientData.goalDate
      )
    }
  },

  watch: {
    $route(to, from) {
      this.currentPath = to.name
    }
  },

  async mounted() {
    this.setPreferenceList()
    await this.getClientData(true)
    this.currentPath = this.$router.currentRoute.name
  },

  methods: {
    submitBasicInfo(data) {
      this.form.userInfo = data
      this.step++
    },
    changedWantsNeeds() {
      this.showWantsNeedsError = false
    },
    submitLegalities(data) {
      this.form.legalities = data
      this.step++
    },
    submitNeeds(data) {
      this.form.needs = data
      if (isEmpty(data)) {
        this.showWantsNeedsError = true
      } else {
        this.form.homePrefs = data.map(item => ({
          ...item,
          ...{ wantNeed: 'Need' }
        }))
        this.step++
      }
    },
    submitWants(data) {
      this.form.wants = data
      if (isEmpty(data)) {
        this.showWantsNeedsError = true
      } else {
        // We don't allow items that are already needs to be added to wants.
        const filteredList = data.filter(v => !this.form.homePrefs.find(v2 => v.text === v2.text))
        this.form.homePrefs = [
          ...this.form.homePrefs,
          ...filteredList.map(item => ({ ...item, ...{ wantNeed: 'Want' } }))
        ]
        if (this.maxStep > 1) this.step++
      }
    },
    submitApprovalLetter(data) {
      this.step++
      if (data) {
        this.form.approvalLetter = data
      }
    },
    submitPurchaseDetails(data) {
      for (let key in data) {
        if (data[key]) {
          this.form.userInfo[key] = data[key]
        }
      }
    },
    async submitData(skip = false) {
      if (skip && this.maxStep > 1) {
        this.$refs.purchaseDetails.submit()
      }
      if (this.maxStep === 1) {
        this.$refs.wants.submit()
      }

      if (!this.showWantsNeedsError) {
        await updateMyProfile({
          ..._.omit(this.form.userInfo, ['email']),
          homePrefs: { options: this.form.homePrefs, freetext: '' }
        })

        // if (this.form.approvalLetter) {
        //   const imageFormData = new FormData()
        //   imageFormData.append('upload', this.form.approvalLetter.newFile)
        //   await uploadProfileMedia(this.clientData._id, 'approval_letter', 'Approval Letter', imageFormData)
        // }
        if (this.isMobile) {
          this.$router.push({ name: 'client-search' })
        } else {
          this.$router.push({ name: 'client-dashboard' })
        }
      }
    },
    nextScreenBtnClick() {
      switch (this.step) {
        // case 0: return this.$refs.basicInfo.submit()
        // case 1: return this.$refs.legalities.submit()
        case 0:
          return this.$refs.needs.submit()
        case 1:
          return this.$refs.wants.submit()
        case 2:
          return this.$refs.purchaseDetails.submit()
      }
    }
  }
}
</script>

<style lang="scss">
button:focus {
  outline: none;
}

#containerClientSignup {
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url("/img/home.jpg");
  background-size: cover;
}

.signup_card_skip {
  margin-top: 15px;
  font-size: 12px;
  color: $hwayzBrandGold;
  cursor: pointer;
}

.signup-card {
  min-height: 90%;
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  background-color: #fff;
  border-radius: 5px;
  position: relative;
}

#signup-card__content {
  height: 100%;
  padding: 20px 0;
  font-size: $hwayzFont1rem6;
}

.signup-card__title {
  text-transform: uppercase;
  color: darkgray;
  font-size: 14px;
}

.signup-card__title-page-name {
  text-transform: uppercase;
  color: black;
  font-size: $hwayzFont1rem8;
  margin-bottom: 3rem;
}

.signup-card__footer {
  margin-top: 20px;
}

.wants-needs-error {
  color: $hwayzRed;
  display: block;
  margin-top: 10px;
}

.buttonContinue {
  border: darkgray 1px solid;
  border-radius: 5px;
  padding: 5px 25px;
  box-shadow: #ababab 0px 2px 2px 1px;
}

#buttonBack {
  position: absolute;
  left: 20px;
  top: 16px;
  color: darkgray;
  font-size: 3.5rem;
  cursor: pointer;
  &:focus {
    outline: none;
  }
}
</style>
